// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"440":"568e9cc9","535":"429afada","611":"3878f01e","989":"bcd0f483","996":"61610e07"}[chunkId] + ".chunk.css";
};